import { Icon } from "@ui/components/Icon";
import { tv, type VariantProps } from "@ui/lib/tv";
import { composeRenderProps } from "@ui/primitives/shared";
import { ToggleButton, type ToggleButtonProps } from "@ui/primitives/ToggleButton";

const heartToggleButton = tv({
  base: "cursor-pointer bg-transparent p-0 disabled:cursor-not-allowed",
  defaultVariants: {
    size: "32",
  },
  variants: {
    size: {
      "24": "[&_svg]:size-6",
      "32": "[&_svg]:size-8",
    },
  },
});

type HeartToggleButtonVariants = VariantProps<typeof heartToggleButton>;

export interface HeartToggleButtonProps extends Omit<ToggleButtonProps, "children"> {
  "aria-label": string;
  size?: HeartToggleButtonVariants["size"];
}

export function HeartToggleButton({ size, ...props }: HeartToggleButtonProps) {
  return (
    <ToggleButton
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        heartToggleButton({ ...renderProps, size, className }),
      )}
    >
      {({ isSelected }) => (
        <Icon name={isSelected ? "heart" : "heartInactive"} shadow="none" size={size ?? "32"} type="sticker" />
      )}
    </ToggleButton>
  );
}
